import {
  type TemplateConfig,
  replaceYears,
  getExperienceYears,
} from '@/mocks/template-config';

interface InstitutionalSectionProps {
  config: TemplateConfig['institutional'];
}

export default function InstitutionalSection({ config }: InstitutionalSectionProps) {
  if (!config.show) return null;

  const years = getExperienceYears(config.foundedYear);
  const yearsText = years >= 30 ? `mais de ${years} anos` : `${years} anos`;
  const mainText = replaceYears(config.text, config.foundedYear);

  const visibleDifferentials = config.differentials.filter((d) => d.show);

  return (
    <div className="bg-brand-dark py-12 md:py-16 px-4">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col md:flex-row gap-8 md:gap-12">
          {/* Left: Text */}
          <div className="flex-1">
            <h2 className="text-white text-xl md:text-2xl font-semibold mb-6">
              {mainText}
            </h2>

            {/* Differentials Grid */}
            {visibleDifferentials.length > 0 && (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {visibleDifferentials.map((item, index) => (
                  <div key={index} className="flex items-center gap-2">
                    <div className="w-5 h-5 rounded-full bg-brand-gold/20 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-brand-gold text-xs" />
                    </div>
                    <span className="text-brand-text text-sm">
                      {replaceYears(item.text, config.foundedYear)}
                    </span>
                  </div>
                ))}
                {config.showCustomDifferential && config.customDifferential && (
                  <div className="flex items-center gap-2">
                    <div className="w-5 h-5 rounded-full bg-brand-gold/20 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-brand-gold text-xs" />
                    </div>
                    <span className="text-brand-text text-sm">{config.customDifferential}</span>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Right: Logo watermark */}
          <div className="hidden md:flex items-center justify-center flex-1">
            <div className="w-48 h-48 rounded-full border border-brand-gold/10 flex items-center justify-center opacity-20">
              <div className="w-32 h-32 rounded-full border border-brand-gold/20 flex items-center justify-center">
                <div className="w-16 h-16 rounded-full bg-brand-gold/10 flex items-center justify-center">
                  <div className="w-6 h-6 bg-brand-gold/20 rounded-full" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}